<template>
  <div class="addstandingBook">
    <PageHead title="发起整改"></PageHead>
    <div class="detial-cont">
      <div class="detial-cont-title">发起任务配置</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-alert
          message="流程提示：1、选择任务机构  2、选择任务时间范围  3、提交"
          type="info"
          show-icon
          class="w500"
          style="margin-bottom: 20px"
        />
        <div class="modalItem">
          <div class="modelTitle">1. 选择任务机构</div>
          <a-tree-select
            multiple
            v-model="taskData.orgIds"
            class="w500"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="treeData"
            placeholder="请选择部门"
            tree-default-expand-all
            :replaceFields="{
              key: 'id',
              value: 'id',
              children: 'treeList',
              title: 'organizationName'
            }"
          >
          </a-tree-select>
        </div>
        <div class="modalItem">
          <div class="modelTitle">2. 选择任务时间范围</div>
          <a-range-picker
            class="w300"
            v-model="timeHorizon"
            :valueFormat="dateFormat"
          ></a-range-picker>
        </div>
        <div class="modalItem">
          <a-switch v-model="remindMethod" /> 系统提醒
        </div>
        <div class="modalItem">
          任务时间截止前
          <a-input-number
            v-model="taskData.remindDay"
            :min="0"
            :max="9999999"
          />
          天，发系统消息提醒。
        </div>
        <div class="modalItem">
          <a-checkbox-group v-model="operator">
            <a-checkbox value="1" name="type"> 任务发起人 </a-checkbox>
            <a-checkbox value="2" name="type"> 任务提交人 </a-checkbox>
          </a-checkbox-group>
        </div>
        <div class="modalItem">
          <a-button
            style="margin-left: 50px"
            type="primary"
            @click="handleOk()"
            :loading="loading"
          >
            确认
          </a-button>
          <a-button style="margin-left: 30px" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { addTask } from './api/api'
export default {
  data() {
    return {
      loading: false,
      remindMethod: true,
      operator: [],
      taskData: {},
      dateFormat: 'YYYY-MM-DD',
      timeHorizon: [] //时间范围
    }
  },
  components: {},
  computed: {
    ...mapState({
      auditTypeList: (state) => state.bytype.auditTypeList, // 	审计类型
      treeData: (state) => state.app.treeData // 组织机构树
    })
  },
  created() {
    this.getorganizeListFn()
    this.getauditType()
  },
  methods: {
    ...mapActions(['getorganizeListFn', 'getauditType']),
    cancel() {
      //取消
      this.taskData = {}
      this.timeHorizon = []
      this.operator = []
    },
    handleOk() {
      if (!this.taskData.orgIds || this.taskData.orgIds.length == 0) {
        //没有选择组织机构
        this.$message.error('请选择任务机构')
        return false
      }
      if (this.timeHorizon.length > 0) {
        //选择了时间范围
        this.taskData.startTime = this.timeHorizon[0]
        this.taskData.endTime = this.timeHorizon[1]
      } else {
        this.$message.error('请选择任务时间范围')
        return false
      }
      if (this.operator.length > 0) {
        //提醒设置
        this.operator.forEach((item, index) => {
          if (item == 1) {
            this.taskData.give = 1
          }
          if (item == 2) {
            this.taskData.receive = 1
          }
        })
      } else {
        this.taskData.give = 2
        this.taskData.receive = 2
      }
      if (this.remindMethod) {
        this.taskData.remindMethod = 1
      } else {
        this.taskData.remindMethod = 2
      }
      this.loading = true
      addTask(this.taskData).then((res) => {
        if (res.data.code == 0) {
          this.$message.success('发起整改任务成功')
          this.taskData = {}
          this.timeHorizon = []
          this.operator = []
          this.loading = false
        } else {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addstandingBook {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;

      .modalItem {
        margin-bottom: 20px;
      }
      .modelTitle {
        padding-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/standingBook/InitiateCorrective.vue